import { render, staticRenderFns } from "./FaqQuestionDetail.vue?vue&type=template&id=c20a7b62&scoped=true&"
import script from "./FaqQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./FaqQuestionDetail.vue?vue&type=style&index=0&id=c20a7b62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20a7b62",
  null
  
)

export default component.exports